<template>
	<div class="app-header-z-index">
		<div
			class="app-header js-app-header"
			:class="{scrolling: scrolled && !menuIsVisible, type: !type && !scrolled}">
			<btn-edit
				v-if="editable"
				class="top-responsive"
				@edit-section="openModal"
			/>
			<div class="app-wrapper">
				<div class="app-header-menu">
					<h1 v-if="companyData.logoCompany && companyData.logoCompany[0]">
						<router-link to="/" class="app-header-link-home">
							<img 
								v-if="!menuIsVisible"
								:src="companyData.logoCompany[0].url"
								:alt="companyData.logoCompany[0].title"
								height="44px"
								width="63px">
							<img
								v-else
								:src="companyData.logoMaster[1].url"
								:alt="companyData.logoMaster[1].title"
								height="44px"
								width="63px">
						</router-link>
					</h1>
					<button
						class="app-header-call-menu"
						@click="toggleMenu()"
						:class="{open: menuIsVisible}"
					>
						<span class="call-menu-line"></span>
						<span class="call-menu-line"></span>
						<span class="call-menu-line"></span>
					</button>
				</div>
				<nav 
					class="app-nav"
					:class="{open: menuIsVisible}">
					<ul class="app-nav-list">
						<template v-for="(item, index) in navigation">
							<li
								:key="item.id"
								v-if="index < 2">
								<a 
									class="app-nav-list-item"
									href="#router"
									@click.prevent="transitionUs"
									v-if="index === 0">
									{{ item.name }}
								</a>
								<router-link v-else
									:to="item.url" 
									class="app-nav-list-item">
									{{ item.name }}
								</router-link>
							</li>
						</template>
						<li class="app-nav-logo">
							<h1 v-if="companyData.logoCompany && companyData.logoCompany[0]">
								<router-link to="/" class="app-nav-list-item">
									<img 
										:src="companyData.logoCompany[0].url"
										:alt="companyData.logoCompany[0].title"
										height="47px"
										width="89px"
									/>
								</router-link>
							</h1>
						</li>
						<template v-for="(item, index) in navigation">
							<li
								:key="item.id"
								v-if="index > 1">
								<a
									class="app-nav-list-item"
									v-if="index === 2"
									href="#router"
									@click.prevent="transitionHistory">
									{{ item.name }}
								</a>
								<a
									v-else
									class="app-nav-list-item"
									href="#router"
									@click.prevent="scrollTo('transition-contact', 1000, false)" >
									Contáctanos
								</a>
							</li>
						</template>
					</ul>
				</nav>
			</div>
		</div>
		<edit-modal-nav
			v-if="openNav"
			:items="itemsNav"
			title="Menú"
			@close-modal="closeModal"
			@save="save"
		/>
	</div>
</template>

<script>
import btnEdit from '@/components/commons/btn-edit';
import editModalNav from '@/components/commons/edit-modal-nav';


const methods = {
	handleWindowWidth() {
		const isMobile = window.innerWidth < 600;
		this.$store.commit('SET_IS_MOBILE', isMobile);
	},
};

function created() {
	window.addEventListener('scroll', this.handleScroll);
	this.loadData();
}

function mounted() {
	this.handleWindowWidth();
	this.topAppHeader = document.getElementsByClassName('js-app-header')[0].offsetTop;
}

function destroyed() {
	window.removeEventListener('scroll', this.handleScroll);
}

function closeModal() {
	this.openNav = false;
	this.itemsNav = [];
}



function handleScroll() {
	if (window.innerWidth > 1024) {
		this.scrolled = window.scrollY > this.topAppHeader - 49;
	} else {
		this.scrolled = window.scrollY > 50;
	}
}

async function loadData() {
	const params = { flagActive: 1 };
	try {
		const { data: navigation } = await this.$http.get(`app/${process.env.APP_CODE}/tags`, { params });
		this.navigation = [...navigation.data];
	} catch (err) {
		if (err.status === 500) {
			this.showError();
		}
	}
}

function openModal() {
	this.itemsNav = this.navigation.map(nav => ({ ...nav }));
	this.openNav = true;
}

function openNav(value) {
	this.onModal(value);
}

async function save(navigation) {
	try {
		await this.$http.patch(`edit/tags/group/${process.env.APP_CODE}`, navigation);
		this.showNotification('La edición del menú ha sido realizada correctamente.');
		this.closeModal();
		this.loadData();
	} catch (err) {
		if (err.status === 500) {
			this.showError();
		}
	}
}

function toggleMenu() {
	this.menuIsVisible = !this.menuIsVisible;
	this.onModal(this.menuIsVisible);
}

function transitionHistory() {
	this.$router.push({ name: 'page-home' });
	setTimeout(() => {
		this.scrollTo('transition-history', 1000, false);
	},
	2000);
}

function transitionUs() {
	this.$router.push({ name: 'page-home' });
	setTimeout(() => {
		this.scrollTo('transition-us', 1000, false);
	},
	2000);
}

function type() {
	return this.$route.name === 'page-home' || this.$route.name === 'page-error';
}

function data() {
	return {
		itemsNav: [],
		menuIsVisible: false,
		navigation: [],
		open: false,
		openNav: false,
		scrolled: false,
		topAppHeader: 0,
		topBtnHeader: 0,
		openSeo: false,
	};
}

export default {
	components: {
		btnEdit,
		editModalNav,
	},
	data,
	created,
	mounted,
	destroyed,
	computed: {
		type,
	},
	methods: {
		...methods,
		closeModal,
		handleScroll,
		loadData,
		openModal,
		save,
		toggleMenu,
		transitionHistory,
		transitionUs,
	},
	props: {
		companyData: {
			default: () => {},
			type: Object,
		},
	},
	watch: {
		openNav,
	},
};
</script>

<style lang="scss" scoped>
	.app-header {
		@include transition(background-color .2s linear 0s);
		background-color: rgba(1, 18, 30, 0.53);
		bottom: 15px;
		padding: 3px 0;
		position: absolute;
		width: 100%;
		z-index: 100;

		&.scrolling {
			@include box-shadow(1px, 2px, 10px, 1px, rgba(map-get($colors, black-dark), .5));
			background: rgba(1, 18, 30, 1);
			bottom: auto;
			height: 68px;
			position: fixed;
			top: 49px;
		}

		&.type {
			bottom: auto;
			top: 307px;
		}

		@media (min-width: 960px) {
			min-height: 61px;
		}
	}

	.app-nav-list {
		@include flex-center();

		@media (min-width: 960px) {
			min-height: 55px;
		}

		> li:last-child {
			.app-nav-list-item {
				margin-right: 0;
			}    
		}
	}

	.app-nav-list-item {
		@include font-size(14);
		color: map-get($colors, white);
		margin-right: 36px;

		&.active {
			@include font-maison-bold();
		}
	}

	.app-header-call-menu {
		@include transform(rotate(0deg));
		@include transition(.5s ease-in-out);
		cursor: pointer;
		height: 14px;
		margin-right: 21px;
		position: relative;
		z-index: 1;

		.call-menu-line {
			@include border-radius(9px);
			@include transform(rotate(0deg));
			@include transition(.5s ease-in-out);
			@include opacity(1);
			background: map-get($colors, white);
			display: block;
			height: 3px;
			left: 0;
			position: absolute;
			width: 18px;

			&:nth-child(1) {
				top: 0px;
				transform-origin: left center;
			}
			&:nth-child(2) {
				top: 5px;
				transform-origin: left center;
			}
			&:nth-child(3) {
				top: 10px;
				transform-origin: left center;
			}
		}
		&.open {
			span:nth-child(1) {
				@include transform(rotate(45deg));
				background: map-get($colors, black);
				left: 3px;
				top: -2px;
			}
			span:nth-child(2) {
				@include opacity(0);
				background: map-get($colors, black);
				width: 0%;
			}
			span:nth-child(3) {
				@include transform(rotate(-45deg));
				background: map-get($colors, black);
				left: 3px;
				top: 10px;
			}
		}
	}

	.app-header-menu {
		display: none;
	}

	@media screen and (max-width: 1024px) {
		.app-header {
			background: transparent;
		}

		.app-wrapper {
			width: 100%
		}

		.app-header-menu {
			@include display-flex();
			align-items: center;
			justify-content: space-between;
			padding: 12px 0px 17px 23px;
			position: fixed;
			width: 90%;
			z-index: 6;
		}

		.app-nav-logo {
			display: none;
		}

		.app-header {
			height: 73px;
			top: 55px;

			&.type {
				height: 73px;
				top: 53px;
			}
		}

		.app-header-link-home {
			display: block;
			height: 44px;
		}

		.app-nav {
			@include transition();
			background-color: map-get($colors, white);
			height: 100vh;
			left: -100%;
			max-width: 450px;
			padding-top: 133px;
			position: fixed;
			top: 0;
			width: 90%;
			z-index: 1;

			&.open {
				@include box-shadow(0, 2px, 6px, 0, rgba(158, 158, 158, 0.5));
				left: 0;		
			}
		}

		.app-nav-list {	
			align-items: flex-start;
			flex-direction: column;

			& > li:nth-child(1), li:nth-child(4)  {
				background: rgba(197, 197, 197, 0.68);
			}

			& > li {
				@include font-maison-demi();
				padding: 24px 0 24px 58px;
				width: 100%;
			}

			.app-nav-list-item {
				@include font-size(14);
				color: map-get($colors, black);
			}
		}		
	}
	
	.app-header-z-index {
		z-index: 100;

		@media (max-width: 964px) {
			position: relative;
		}
	}

	.top-responsive {
		top: 8px !important;

		@media (min-width: 964px) {
			top: 2px !important;
		}
	}
</style>





// WEBPACK FOOTER //
// src/components/commons/header.vue